import { render, staticRenderFns } from "./Section.vue?vue&type=template&id=1b4c00a3&scoped=true&"
import script from "./Section.vue?vue&type=script&lang=js&"
export * from "./Section.vue?vue&type=script&lang=js&"
import style0 from "./Section.vue?vue&type=style&index=0&id=1b4c00a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4c00a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b4c00a3')) {
      api.createRecord('1b4c00a3', component.options)
    } else {
      api.reload('1b4c00a3', component.options)
    }
    module.hot.accept("./Section.vue?vue&type=template&id=1b4c00a3&scoped=true&", function () {
      api.rerender('1b4c00a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/ExtendMenu/Section.vue"
export default component.exports